import { render } from "./lifeGuidance.vue?vue&type=template&id=50eac748&scoped=true"
import script from "./lifeGuidance.vue?vue&type=script&lang=js"
export * from "./lifeGuidance.vue?vue&type=script&lang=js"

import "./lifeGuidance.vue?vue&type=style&index=0&id=50eac748&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50eac748"]])

export default __exports__